import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getalumniFeedbackAPi,deletealumniFeedbackApi } from "../../../ApiUrl";
export const token = sessionStorage.getItem("accessToken")

const headers = {
    Authorization: `Bearer ${token}`,
};
// get alumniFeedback
export const getalumniFeedback = createAsyncThunk('getalumniFeedback/alumniFeedback', async () => {
    try {
        const response = await axios.get(`${getalumniFeedbackAPi}?limit=`, { headers });
        return response.data; 
    } catch (error) {
        throw new Error(error.message);
    }
});

// delete alumniFeedback
export const deletealumniFeedbacks = createAsyncThunk('deletealumniFeedbacks/alumniFeedback', async (alumniFeedbackid, { rejectWithValue }) => {
    try {
        const response = await axios.delete(`${deletealumniFeedbackApi}/${alumniFeedbackid}`, { headers });
        return response.data._id; // Assuming your API response contains a 'alumniFeedbackid' property
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
});



const alumniFeedbackSlice = createSlice({
    name: 'alumniFeedback',
    initialState: {
        alumniFeedbacks: [],
        status: 'idle',
        error: null,
        message: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            //getalumniFeedbacks
            .addCase(getalumniFeedback.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getalumniFeedback.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.alumniFeedbacks = action.payload;
            })
            .addCase(getalumniFeedback.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            })

            //delete alumniFeedbacks
            .addCase(deletealumniFeedbacks.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deletealumniFeedbacks.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.alumniFeedbacks.data = state.alumniFeedbacks.data.filter(alumniFeedbacks => alumniFeedbacks.alumniFeedbackid !== action.payload);
                state.status = 'idle'
            })
            .addCase(deletealumniFeedbacks.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
    }
});

export default alumniFeedbackSlice.reducer;
